// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2WCPK","actions":"GroupTable_actions__3E_Cv","deleteModalFooter":"GroupTable_deleteModalFooter__3XPj2"};